module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('recommend'), _vm._v(" "), _vm._l((_vm.catalogArr), function(cat, index) {
    return _c('div', {
      staticClass: "contentBox"
    }, [_c('div', {
      staticClass: "titleBox"
    }, [_c('div', {
      staticClass: "titleInfo"
    }, [(index % 3 == 0) ? _c('Icon', {
      attrs: {
        "type": "bookmark",
        "color": "#f96650",
        "size": "20"
      }
    }) : (index % 3 == 1) ? _c('Icon', {
      attrs: {
        "type": "bookmark",
        "color": "#789262",
        "size": "20"
      }
    }) : _c('Icon', {
      attrs: {
        "type": "bookmark",
        "color": "#276793",
        "size": "20"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "titleTxt"
    }, [_vm._v(_vm._s(cat.catalog))])], 1), _vm._v(" "), _c('div', {
      staticClass: "moreIcon"
    }, [_c('router-link', {
      attrs: {
        "exact": "",
        "to": '/classifydetails/' + cat.id + '&' + cat.catalog
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0);",
        "title": "更多"
      }
    }, [_c('Icon', {
      attrs: {
        "type": "ios-arrow-right",
        "color": "#808080",
        "size": "20"
      }
    })], 1)])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "containerBox"
    }, _vm._l((_vm.catalogBody[cat.id]), function(body) {
      return _c('div', {
        staticClass: "bookBox"
      }, [_c('router-link', {
        attrs: {
          "exact": "",
          "to": '/bookdetails/' + body.title + '&' + cat.id
        }
      }, [_c('img', {
        directives: [{
          name: "lazy",
          rawName: "v-lazy",
          value: (body.img),
          expression: "body.img"
        }],
        staticClass: "bookImg"
      })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(body.title))])], 1)
    })), _vm._v(" "), _c('div', {
      staticClass: "bottomBox"
    }, [_c('router-link', {
      attrs: {
        "exact": "",
        "to": "/classify",
        "tag": "p"
      }
    }, [_vm._v("\n        查看更多\n        "), _c('Icon', {
      attrs: {
        "type": "ios-arrow-thin-right",
        "size": "12"
      }
    })], 1)], 1)])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-0ec1790c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/IndexContent.vue
// module id = 178
// module chunks = 1